import React from 'react'
import styled from '@emotion/styled';
import { Box, Card, Dialog, Grid, Typography } from '@mui/material';

const Item = styled(Card)(({ theme }) => ({
  backgroundColor: "#fff",
  boxShadow: 'none',
  borderRadius: '10px',
  padding: '10px',
}));

function GallaryImageSelectDialog({ cloudImageSelectDialog, cloudImageSelectDialogClose, gallary, selectImageFromCloud }) {
  return (
    <Dialog
      fullWidth={true}
      maxWidth="xl"
      open={cloudImageSelectDialog}
      onClose={() => cloudImageSelectDialogClose()}
    >
      <Grid container spacing={2} sx={{ padding: 2, backgroundColor: '#F4F4F4' }}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Item>
            <Box className="section-category-header-flex">
              <div className='category-header-icon'></div>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                Gallary List
              </Typography>
            </Box>
          </Item>
        </Grid>
        {gallary && gallary.length === 0 ? (
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Item>
              <Typography textAlign="center" sx={{ fontWeight: 'bold', fontSize: 20 }}>No Records Found...</Typography>
            </Item>
          </Grid>
        ) : (gallary && gallary.map((item, index) => (
          <Grid item xs={12} sm={6} md={6} lg={4} key={index}>
            <Item onClick={() => { selectImageFromCloud(item) }}>
              <div className="container">
                <img src={item?.url} alt="Avatar" className="image" />
              </div>
            </Item>
          </Grid>
        )))}
      </Grid>
    </Dialog>
  )
}

export default GallaryImageSelectDialog;